import { type MaybeRefOrGetter, toValue } from 'vue'

import type { CTALink } from '@backmarket/http-api/src/api-specs-content/models/cta-link'

import { useLinkTarget } from './useLinkTarget'

export function useCTALinkTarget(
  ctaLink: MaybeRefOrGetter<CTALink | undefined>,
) {
  return useLinkTarget(() => toValue(ctaLink)?.link)
}
